import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from 'react-router-dom';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function ProductPage() {

  const [rows, setRows] = useState([]);

  const [data, setData] = useState({
    name: "",
    code: "",
    unit: "",
    description: ""
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    axios.get(baseUrl + "products/")
      .then(res => {
        setRows(res.data);
      });
  };

  const inputHandler = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const formSubmit = () => {

    if (!data.name || !data.code) {
      Swal.fire("Error", "Name and Code are required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("name", data.name);
    _formData.append("code", data.code);
    _formData.append("unit", data.unit);
    _formData.append("description", data.description);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.post(baseUrl + "products/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then((response) => {
      if (response.status === 200 || response.status === 201) {

        Swal.fire({
          title: "Product Created",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });

        setData({
          name: "",
          code: "",
          unit: "",
          description: ""
        });

        fetchData();
      }
    })
    .catch(() => {
      Swal.fire("Error", "Code must be unique", "error");
    });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Confirm",
      text: "Are you sure you want to delete this?",
      icon: "warning",
      confirmButtonText: "Yes",
      showCancelButton: true
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + "products/" + id + "/")
          .then(() => {
            Swal.fire("Deleted", "Product deleted", "success");
            fetchData();
          });
      }
    });
  };

const columns = [
  { field: "id", headerName: "ID", width: 80 },
  { field: "name", headerName: "Product Name", flex: 1 },
  { field: "code", headerName: "Code", flex: 1 },
  { field: "unit", headerName: "Unit", flex: 1 },
  { field: "description", headerName: "Description", flex: 1 },
   { field: 'edit', headerName: 'Edit',
        renderCell: (params) => (
          <Link to={`/products/edit/${params.row.id}`} target="_blank" className="btn btn-warning">
            Edit
          </Link>
      ),
      width: 120 },
      { field: 'delete', headerName: 'Action',
        renderCell: (params) => (
          <button onClick={()=> handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
          <i className="fa-solid fa-trash-can"></i></button>
      ),
      width: 120 },
];

  return (
    <div className="container mt-4">

      {/* Form Card */}
      <div className="card p-4 mb-4">
        <h4>Add Product</h4>

        <input
          type="text"
          className="form-control mt-3"
          placeholder="Product Name"
          name="name"
          value={data.name}
          onChange={inputHandler}
        />

        <input
          type="text"
          className="form-control mt-3"
          placeholder="Product Code"
          name="code"
          value={data.code}
          onChange={inputHandler}
        />

        <input
          type="text"
          className="form-control mt-3"
          placeholder="Unit (e.g., Kg, Nos, Ltr)"
          name="unit"
          value={data.unit}
          onChange={inputHandler}
        />

        <textarea
          className="form-control mt-3"
          placeholder="Description"
          name="description"
          value={data.description}
          onChange={inputHandler}
        />

        <button
          className="btn btn-success mt-3"
          onClick={formSubmit}
        >
          Submit
        </button>
      </div>

      {/* DataGrid */}
      <div className="card p-3">
        <DataGrid
           sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
          rows={rows}
          columns={columns}
          pageSize={10}
          autoHeight
          components={{ Toolbar: GridToolbar }}
        />
      </div>

    </div>
  );
}

export default ProductPage;
